import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DivisionService {

  constructor(private http: HttpClient) { }

  getAllDivisions() {
    return this.http.get(`${environment.apiUrl}/globalvision/division`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }
  getAllAreaStore() {
    return this.http.get(`${environment.apiUrl}/globalvision/areastore`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }
}
